import React from "react";
import Meta from "../Meta";
import Loader from "../loader";
import ContentHubComponent from "../../../components/ContentHub";
import { t } from "@lingui/core/macro";

export default function ContentHub({ context, loading }) {
    const hub = context?.contentHub || {};
    const article = hub?.article;

    const title = hub.view === "article" && article
        ? article.title
        : t`Explorer la bibliothèque`;
    const description = hub.view === "article" && article
        ? (article.description || "")
        : t`Parcourez articles et catégories.`;

    if (loading) {
        return (
            <>
                <Meta context={context} title={title} description={description} />
                <Loader />
            </>
        );
    }

    return (
        <>
            <Meta context={context} title={title} description={description} />
            <div style={{ padding: "0 clamp(16px, 4vw, 32px)", maxWidth: "var(--container)", margin: "0 auto" }}>
                <ContentHubComponent context={context} />
            </div>
        </>
    );
}
